import { Fragment } from "react";
import { isValidArray } from "../../Layout/Common/common";
import styles from "./StaticPage.module.css";

/* Each block is a div, not a p. Several pages put <p> tags inside their content
   (About, Contact Us, Job Enquiries); wrapping those in a <p> made the browser
   auto-close the outer one, which is what produced the uneven paragraph gaps. */
export const BodyContent = ({ content }) => {
  if (!isValidArray(content)) {
    return <></>;
  }

  return (
    <Fragment>
      {content.map((block, index) => (
        <div className={styles.block} key={index}>
          {block.title && (
            <h3 className={block.section ? styles.sectionTitle : styles.blockTitle}>{block.title}</h3>
          )}
          {block.content}
        </div>
      ))}
    </Fragment>
  );
};
